import React, { createContext, useContext, useCallback, useState, ReactNode } from 'react';

interface checkoutInfoContextProps {
  selShipping: boolean;
  onSetSelShipping: (stateInvert: boolean, state?: boolean) => void;
  onSetaddressSelect: ({id, type} : AddressSelectedProps) => void;
  addressSelected: AddressSelectedProps;
  onsetMethodSelect: ({id, type} : MethodSelectedProps) => void;
  methodSelected: MethodSelectedProps;
  createCustomer: number;
  onSetCreateCustomer: (state: number) => void;
  customerIsSignedIn: boolean;
  onSetCustomerIsSignedIn: (state: boolean) => void;
}

interface CheckoutInfoProviderProps {
  children: ReactNode;
}

export interface AddressSelectedProps {
  type: 'addressUser' | 'addressStore' | 'addressLocker';
  id: number;
}

interface MethodSelectedProps {
  type: number;
  id: number;
}

const checkoutInfoContext = createContext({} as checkoutInfoContextProps);

const CheckoutInfoProvider: React.FC<CheckoutInfoProviderProps> = ({children} : CheckoutInfoProviderProps) => {
  const [selShipping, setSelShipping] = useState(false); // default:false
  const [addressSelected, setaddressSelect] = useState<AddressSelectedProps>({} as AddressSelectedProps);
  const [methodSelected, setMethodSelect] = useState<MethodSelectedProps>({} as MethodSelectedProps);
  const [createCustomer, setCreateCustomer] = useState(0);
  const [customerIsSignedIn, setCustomerIsSignedIn] = useState(false);
  
  const onSetCustomerIsSignedIn = useCallback((state: boolean) => {
    setCustomerIsSignedIn(state);
  }, [setCustomerIsSignedIn]);

  const onSetCreateCustomer = useCallback((state: number) => {
    setCreateCustomer(state);
  }, [setCreateCustomer]);

  const onSetSelShipping = useCallback((stateInvert: boolean, state?: boolean) => {
    if (stateInvert === true) {
      setSelShipping(v => !v);
    }
    else if (state){
      setSelShipping(state);
    }
  }, []);

  const onSetaddressSelect = useCallback(({id, type} : AddressSelectedProps) => {
    setaddressSelect({type, id});
  }, []);

  const onsetMethodSelect = useCallback(({id, type} : MethodSelectedProps) => {
    setMethodSelect({type, id});
  }, []);

  return (
    <checkoutInfoContext.Provider value={{ 
      selShipping, 
      onSetSelShipping, 
      onSetaddressSelect,  
      addressSelected, 
      onsetMethodSelect, 
      methodSelected,
      createCustomer,
      onSetCreateCustomer,
      customerIsSignedIn,
      onSetCustomerIsSignedIn,
      }}>
      {children}
    </checkoutInfoContext.Provider>
  );
}

function useCheckoutInfo(): checkoutInfoContextProps {
  const context = useContext(checkoutInfoContext);

  if (!context) {
    throw new Error(
      'FilterProductContext must be used within a useFilterProduct',
    );
  }

  return context;
}

export { CheckoutInfoProvider, useCheckoutInfo };
